export const parseSearchResults = (data) => {
    const searchData = data?.search_results?.map((item) => {
        return {
            id: item.id,
            name: item.name,
            type: item.type,
            slug: item.url,
        }
    })

    const suggestionsData = data?.search_suggestions?.results?.map((item) => {
        return {
            id: item.id,
            name: item.name,
            type: item.type,
            slug: item.url,
        }
    })

    const getResultType = () => {
        if (data?.result_found) {
            return "RESULTS"
        } else if (data?.search_suggestions?.results?.length) {
            return "SUGGESTIONS"
        } else {
            return "NORESULTS"
        }
    }

    return {
        searchResults: {
            header: "",
            data: searchData,
        },
        searchSuggestions: {
            header: data?.search_suggestions?.display_text,
            data: suggestionsData,
        },
        searchResponseType: getResultType(),
    }
}
